module.exports = __webpack_public_path__ + "img/map.76383c91.png";